export default __webpack_public_path__ + "static/our-approach-4df6b9016e4996953ff5eacf24a7d523.jpg";